module.exports = __webpack_public_path__ + "img/icon_ai.2480f223.svg";